/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import {connect} from 'react-redux'
import { browserHistory } from 'react-router';
import MainItemTitle from './MainItemTitle'
import MainItemList from './MainItemList'
import MainItemBlock from './MainItemBlock'
import ManageBtn from '../../images/liveroomSetting/liveroom-setting-manage.png'
import BanBtn from '../../images/liveroomSetting/liveroom-setting-ban.png'


class MainManageList extends React.Component {

    render() {
        const {liveroomSetting} = this.props;
        const manageBtn = {
            img: ManageBtn,
            text: '管理员',
            method: () => {
                location.assign(`/liveroom/${liveroomSetting.liveroom_id}/edit/manage`);
            }
        };
        const banBtn = {
            img: BanBtn,
            text: '黑名单',
            method: () => {
                location.assign(`/liveroom/${liveroomSetting.liveroom_id}/edit/ban`);
            }
        };
        return (
            <div className="mianpage-manage-list">
                <MainItemTitle content={'管理工具'}/>

                <MainItemList>
                    <MainItemBlock blockContent={manageBtn}/>
                    <MainItemBlock blockContent={banBtn}/>
                    <MainItemBlock nopic={true}/>
                    <MainItemBlock nopic={true}/>
                </MainItemList>
            </div>
        )
    }
}

export default connect(state => ({
    liveroomSetting: state.liveroomSetting
}))(MainManageList)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainManageList.js